import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga';
import * as moment from 'moment';
import { ref,  base, new_pixel_id } from '../../../config/constants.js'

import createBrowserHistory from 'history/createBrowserHistory';
import { getFootballTeamFromOrderObject } from '../FacebookPixelFunctions/PixelFunctions';
const history = createBrowserHistory({ forceRefresh: true });
ReactPixel.init(new_pixel_id);

// itemSelected, 
// name, 
// user,
// numOrders
// phone
// phone2
// address
//shirtSizeAndQtys
//singleOrderArray

/**
    * WHERE ORDER IS ACTUALLY PLACED IN FIREBASE
    */
export function getOrderNumberAndSaveOrder(orderNum, orderObject) {
    console.log("orderx14 cox41 getOrderNumberAndSaveOrder +++++:" + orderNum);
    console.log("orderx15 cox42 - orderObject:" + JSON.stringify(orderObject, null, 3))

    let newPostKey = ref.child('orders').push().key;
    console.log("orderx16 cox43 newPostKey:" + newPostKey);

    // amp_logOrderPlaced(orderObject);
    ref.child('orders/' + newPostKey).set(getNewOrderObject(orderNum, orderObject));
    console.log("orderx16 cox44 orders placed:" + ref.child);

    saveAllSingleOrders(newPostKey, orderObject);

    //SAVE BACK UP..
    //ref.child('backups/' + newPostKey).set(getNewOrderObject(orderNum, orderObject));

    backUpOrder(newPostKey);

    facebookLogOrderPlaced(orderObject);

    //IVAN PUSH
    //history.push('/OrderComplete');
}

async function backUpOrder(newPostKey) {
    console.log("orderx20 ++++++++++++ backUpOrder");
    console.log("orderx21 newPostKey:" + newPostKey);

    base.fetch('orders/' + newPostKey, {
        context: this,
        asArray: false
    }).then(data => {
        console.log("orderx22:" + JSON.stringify(data, null, 3));

        base.post('backups/' + newPostKey, {
            data: data,
            then(err) {
                if (!err) {
                    console.log("orderx23 backupdone:");
                }
            }
        });
    }).catch(error => {
        //handle error
    })


}


function saveAllSingleOrders(mainOrderKey, orderObject) {
    console.log("orderx16 cox51 ++++++++++++ saveAllSingleOrders");
    console.log("orderx17 cox52 singleOrderArray size:"+orderObject.singleOrderArray.length);
    console.log("orderx18 cox53 mainOrderKey:"+mainOrderKey);

    orderObject.singleOrderArray.map((singleOrder, index) => {

        let singleOrderKey = ref.child('orders/' + mainOrderKey + '/singleOrders').push().key;

        singleOrder.singleOrderKey = singleOrderKey;

        // let singleOrderKey = ref.child('orders/' + mainOrderKey+ '/singleOrders'.push().key);
        console.log("orderx19 singleOrderKey:" + singleOrderKey);

        ref.child('orders/' + mainOrderKey + '/singleOrders/' + singleOrderKey).set(singleOrder);

        // SET SINGLE UPDATE..
        console.log("orderx19 saving single udpate index is:"+index);
        ref.child('orders/' + mainOrderKey + '/algoliaSingleOrders/' + index).set(singleOrder);

    })

    // history.push('/OrderComplete');
}

/**
 * 
    * GET OBJECT OF THE ORDER
    */
function getNewOrderObject(orderNum, orderObject) {
    console.log("fixx41 ++++++++++++++++:getNewOrderObject");


    var d = new Date();
    var n = d.toString();
    let now = moment().format('MMMM Do YYYY, h:mm:ss a');

    let tempOrderNum = orderNum ? orderNum : 'na';

    //CALC NUMBER OF ORDERS
    let tempNumOrders = orderObject.numOrders;

    //GET ORDER DESCRIPTION
    let description = orderObject.name
        + ' ordered '
        + orderObject.itemSelected;

    //GET ORDERED BY
    let enteredBy = 'normalUser@printboda.com';
    if (orderObject.user && orderObject.user !== '' && orderObject.user.email) {
        console.log("ux1 user.email is valid and there:" + orderObject.user.email);
        enteredBy = orderObject.user.email;
    }else{
        enteredBy = 'normalUser@printboda.com';
    }

    let newOrder = {
        itemType: orderObject.itemSelected,
        quantity: orderObject.numOrders,
        email: orderObject.email,
        orderEntryComplete: 'no',
        status: 'new',
        phone: orderObject.phone,
        phone2: orderObject.phone2,
        name: orderObject.name,
        address: orderObject.address,
        special_instructions: orderObject.special_instructions,
        adset: orderObject.adset,
        pricing_notes: orderObject.pricing_notes,
        replacement: orderObject.replacement,
        replacementReason: orderObject.replacementReason,
        orderSource: orderObject.orderSource,
        dateString: now,
        dateNum: d.getTime(),
        //IMAGE
        // imageUploaded: .uploadComplete,
        // imageUrl: .imageUrl,
        //T-SHIRTS
        shirtColor: 'blank',
        shirtSize: 'blank',

        shirtType: 'blank',
        description: description,
        order_num: tempOrderNum,
        // shirtSizeAndQtys: orderObject.shirtSizeAndQtys,
        enteredBy: enteredBy,
        sendNewOrderSms: orderObject.sendNewOrderSms,


    }

    //ADD TEMPLATE ID
    if (orderObject.templateId) {
        newOrder.templateId = orderObject.templateId;
    }

    //ADD ITEM CODE
    if (orderObject.itemCode) {
        newOrder.itemCode = orderObject.itemCode;
    }

    //TEMPLATE TYPE
    if (orderObject.templateType) {
        newOrder.templateType = orderObject.templateType;
    }

    //FOR TEMPLATE ADD SPECIAL STUFF
    console.log("pxxx112 - orderObject.itemSelected:" + orderObject.itemSelected);
    if (orderObject.itemSelected === 'template') {
        console.log("pxxx1 - orderObject.itemSelected === 'template'");
        console.log("pxxx12 - orderObject.designImageUrl:" + orderObject.designImageUrl);


        //DESIGN IMAGE
        newOrder.designImageUrl = orderObject.designImageUrl
        newOrder.designUpdated = now,
            //shirt text
            newOrder.shirtText = 'template - ' + orderObject.shirtText,
            newOrder.shirtBackText = 'none';
    } else {
        // console.log("pxxx13 - orderObject.itemSelected IS NOT 'template'");
    }

    //ADD DESIGN IMAGE URL
    if (orderObject.designImageUrl) {
        // console.log("pxxx14 designImageUrl is there:"+orderObject.designImageUrl);
        //DESIGN IMAGE
        newOrder.designImageUrl = orderObject.designImageUrl
        newOrder.designUpdated = now
    } else {
        console.log("pxxx15 - designImageUrl is IS NOT there");
    }

    //ADD DESIGN IMAGE URL
    if (orderObject.shirtText) {
        // console.log("pxxx16 shirtText is there:"+orderObject.shirtText);
        //DESIGN IMAGE
        //shirt text
        newOrder.shirtText = 'template - ' + orderObject.shirtText,
            newOrder.shirtBackText = 'none';
    } else {
        console.log("pxxx17 - shirtText is IS NOT there");
    }

    //FOR SINIYA
    if (orderObject.siniya) {
        //console.log('sinx1 siniya is there:'+orderObject.siniya);
        newOrder.siniya = orderObject.siniya;
    } else {
        // console.log('sinx2 siniya is NOT there:');
    }

    if (orderObject.bringJersey) {
        newOrder.bringJersey = orderObject.bringJersey
    }

    if (orderObject.orderType) {
        newOrder.orderType = orderObject.orderType
    }

    if (orderObject.gender) {
        newOrder.gender = orderObject.gender
    }


    //COUPON CODE
    if (orderObject.couponCode) {
        newOrder.couponCode = orderObject.couponCode
    }

    if (orderObject.salesPerson) {
        newOrder.salesPerson = orderObject.salesPerson
    }

    if (orderObject.sendDesignToSales) {
        newOrder.sendDesignToSales = orderObject.sendDesignToSales
        console.log("sendDesignToSales19  newOrder.sendDesignToSales:" + newOrder.sendDesignToSales);
    }else{
        console.log("sendDesignToSales191 newOrder.sendDesignToSales doesn't exist" );
    }

    if (orderObject.salesPerson_phone) {
        newOrder.salesPerson_phone = orderObject.salesPerson_phone;
        console.log("sendDesignToSales190  newOrder.salesPerson_phone:" + newOrder.salesPerson_phone);
    }else{
        console.log("sendDesignToSales192 newOrder.salesPerson_phone doesn't exist" );
    }

    if (orderObject.large_project_item) {
        newOrder.large_project_item = true;
    }

    if (orderObject.idlarge_project_item) {
        newOrder.idlarge_project_item = orderObject.idlarge_project_item;
    }

    if (orderObject.design_auto_sent) {
        newOrder.design_auto_sent = orderObject.design_auto_sent;
    }

    

    //TOTAL SHIRTS
    let tempTotalShirts = 0;

    newOrder.numOrders = orderObject.numOrders;
    newOrder.totalShirts = countTotalShirts(orderObject.singleOrderArray);
    //console.log("tempNumOrders:" + tempNumOrders);

    //SET DESCRIPTION
    newOrder.description = description;

    return newOrder;
}

/**
* GET THE TOTAL NUMBER OF SHIRTS IN THE ORDER
*/
function countTotalShirts(singleOrderArray) {
    console.log("tx1 +++++++ - count total shirts");

    let totalShirts = 0;
    singleOrderArray.map((order) => {
        totalShirts += parseInt(order.qty);
        console.log("total is now:" + totalShirts);
    })

    console.log("tx2 total is now:" + totalShirts);
    return totalShirts;
}

function amp_logOrderPlaced(orderObject) {

    //let eventProperties = {};
    var eventProperties = {
        itemType: orderObject.itemSelected,
        itemOrdered: orderObject.itemSelected,
        imageUploaded: orderObject.uploadComplete,
        admin: orderObject.admin,
        totalShirts: countTotalShirts(orderObject.singleOrderArray),
        numOrders: orderObject.singleOrderArray.length,
    }


    facebookLogOrderPlaced(orderObject);

}


function facebookLogOrderPlaced(orderObject) {
    console.log("orderx23:+++++++++++: facebookLogOrderPlaced ::::::::::");
    console.log("orderx24:" + JSON.stringify(orderObject, null, 3));

    let price = 10;
    switch (orderObject.itemSelected) {
        case 'football':
            price = 11;
            break;
        case 't-shirts':
            price = 10;
        default:
            price = 10;
    }

    let specificThing = orderObject.itemSelected;
    switch (orderObject.itemSelected) {
        case 'football':
            specificThing = getFootballTeamFromOrderObject(orderObject);
            break;
        case 't-shirts':
            specificThing = orderObject.itemSelected;
        default:
            specificThing = orderObject.itemSelected;
    }

    // GET ITEM CODE IF IT IS A TEMPLATE
    if (orderObject.itemCode) {
        console.log("orderx25:orderObject.itemCode exists:" + orderObject.itemCode);

        specificThing = orderObject.itemCode;
        console.log("orderx26: specific with itemCode:" + specificThing);
    } else {
        console.log("orderx27: orderObject.itemCode DOES NOT exist");
    }

    //ADD ADMIN TO SPECIFIC THING.. 
    if (orderObject.admin) {
        console.log("orderx28:orderObject.admin exists");

        specificThing = specificThing + "_admin_" + orderObject.admin;
        console.log("orderx29:specific with admin:" + specificThing);
    } else {
        console.log("orderx30:orderObject.admin DOES NOT exist");
    }


    console.log("orderx31:+++++++++++: facebookLogOrderPlaced ::::::::::");
    console.log("orderx32: orderObject.itemSelected:" + orderObject.itemSelected);
    console.log("orderx33: price:" + price);
    console.log("orderx34: specificThing:" + specificThing);


    ReactPixel.track('Purchase', {
        content_name: specificThing,
        content_category: orderObject.itemSelected,
        content_ids: [orderObject.itemSelected],
        content_type: 'product',
        value: price,
        currency: 'USD'
    })

    ReactGA.event({
        category: 'User',
        action: 'purchase'
    });

    //IVAN PUSH
    console.log("orderx34: history.push('/OrderComplete')");
    history.push('/OrderComplete');
}


// WEBPACK FOOTER //
// ./src/components/newSite/SaveOrderFunction/SaveOrderFunction.js